// Bean Brothers Retail Theme JS

document.addEventListener('DOMContentLoaded', () => {

  // === Fixed header offset ===
  // Keeps --site-top-h equal to the fixed announcement bar + header height,
  // so main content clears it (announcement bar can be closed at any time).
  const siteTop = document.querySelector('.site-top');
  if (siteTop) {
    const setSiteTopHeight = () =>
      document.documentElement.style.setProperty('--site-top-h', siteTop.offsetHeight + 'px');
    setSiteTopHeight();
    new ResizeObserver(setSiteTopHeight).observe(siteTop);
  }

  // === Mobile menu accordions (KR) ===
  // On mobile, tapping a top-level item with sub-links (or the SEARCH row)
  // expands it in place instead of navigating. One item open at a time.
  document.querySelectorAll('.main-nav .nav-item').forEach((item) => {
    const link = item.querySelector(':scope > a');
    const expandable = item.querySelector(':scope > .nav-dropdown') || item.classList.contains('nav-item--search');
    if (!link || !expandable) return;
    link.addEventListener('click', (e) => {
      if (window.innerWidth > 768) return;
      const wasOpen = item.classList.contains('nav-item--open');
      // 2nd tap on an open item with a real URL navigates (e.g. SUBSCRIBE -> /pages/subscribe)
      if (wasOpen && link.getAttribute('href') && link.getAttribute('href') !== '#' && !item.classList.contains('nav-item--search')) return;
      e.preventDefault();
      document.querySelectorAll('.main-nav .nav-item--open').forEach((o) => o.classList.remove('nav-item--open'));
      if (!wasOpen) {
        item.classList.add('nav-item--open');
        const input = item.querySelector('input');
        if (input) setTimeout(() => input.focus(), 50);
      }
    });
  });

  // === Back to top ===
  const backToTop = document.querySelector('.back-to-top a');
  if (backToTop) {
    backToTop.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // === Product image thumbnails ===
  document.querySelectorAll('.product-main__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.imgSrc;
      const featured = document.getElementById('product-featured-img');
      if (featured && src) {
        featured.src = src;
        document.querySelectorAll('.product-main__thumb').forEach(t =>
          t.classList.remove('product-main__thumb--active')
        );
        thumb.classList.add('product-main__thumb--active');
      }
    });
  });

  // === Quantity buttons ===
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const action = btn.dataset.action;
      let val = parseInt(input.value) || 1;
      if (action === 'increase') val++;
      if (action === 'decrease' && val > 1) val--;
      input.value = val;
    });
  });

  // === Away-tab title ("Brewing...") ===
  if (window.bbAwayTitle) {
    const originalTitle = document.title;
    let awayTimer = null;
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        let dots = 0;
        awayTimer = setInterval(() => {
          dots = (dots % 3) + 1;
          document.title = window.bbAwayTitle + '.'.repeat(dots);
        }, 500);
      } else {
        clearInterval(awayTimer);
        document.title = originalTitle;
      }
    });
  }

  // === Product description toggle ===
  const descToggle = document.querySelector('[data-toggle-desc]');
  const descContent = document.querySelector('[data-desc-content]');
  if (descToggle && descContent) {
    descToggle.addEventListener('click', () => {
      const isHidden = descContent.style.display === 'none';
      descContent.style.display = isHidden ? 'block' : 'none';
      descToggle.querySelector('.toggle-icon').textContent = isHidden ? '−' : '+';
    });
  }

});
